import { api_GET } from "./_api.js";

const setup_api = {
    GetLinkApp: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET("Setup/GetLinkApp")
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  }
}

export default setup_api;